// M016 contact teaser
function initContactTeaser() {

    if ($(".contactTeaserElementSlider").length > 0) {

        $(".contactTeaserElementSlider").each(function () {
            if ($(this).children(".contactTeaserElement").length > 1) {

                $(this).slick({
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: true,
                    prevArrow: slickPrevArrowCode,
                    nextArrow: slickNextArrowCode,
                    adaptiveHeight: false,
                    responsive: [
                        {
                            breakpoint: _breakpointXLarge,
                            settings: {slidesToShow: 3}
                        },
                        {
                            breakpoint: _breakpointLarge,
                            settings: {slidesToShow: 2}
                        },
                        {
                            breakpoint: _breakpointMedium,
                            settings: {slidesToShow: 1}
                        }
                    ]
                });
                $(this).on("afterChange", function (event, slick, direction) {
                    //revalidate images after slider change
                    if (_blazy) {
                        _blazy.revalidate();
                    }
                });

            }
        })


    }
}

function updateContactTeaser() {

    if ($(".contactTeaser").length > 0) {
    
        $(".contactTeaser").each(function(){
            $ct = $(this);

            if ($ct.find(".contactTeaserElementBlock").length > 0) {
                var hh = 0;
    
                $ct.find(".contactTeaserElementBlock").css("height", "auto");
                $ct.find(".contactTeaserElementBlock").each(function () {
                    if ($(this).height() > hh) {
                        hh = Math.ceil($(this).outerHeight());
                    }
                });
                if (hh > 0) {
                    $ct.find(".contactTeaserElementBlock").css("height", hh + "px");
                }
            }
        });
    }
}
